import { ActionListModel } from "@genexus/chameleon-controls-library";
import { TypeCategoryData } from "../..";
import { TypeData } from "./new-object";

export type ChCheckboxArray = HTMLChCheckboxElement[] | null;

export const mapTypeCategoryDataToActionListModel = (
  categories: TypeCategoryData[]
): ActionListModel => {
  return categories.map(category => {
    return {
      id: category.id,
      type: "actionable",
      additionalInformation: {
        "stretch-start": {
          center: [{ imgSrc: category.icon || undefined }]
        }
      },
      caption: category.name,
      part: `category-${category.id}`
    };
  });
};

export const mapTypeDataToActionListModel = (
  types: TypeData[],
  selectedCategoryId: string,
  selectedTypeId?: string
): ActionListModel => {
  return types.map(type => {
    return {
      id: `${type.id}`,
      type: "actionable",
      imageSrc: "objects/design",
      selected: selectedTypeId === type.id,
      additionalInformation: {
        "stretch-start": {
          center: [{ imgSrc: type.icon }]
        }
      },
      caption: type.name,
      part: `type-${selectedCategoryId}-${type.id}`
    };
  });
};
